import React, { useState } from 'react';
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { BookNowPage } from './pages/BookNowPage';
import { ContactPage } from './pages/ContactPage';
import { HomePage } from './pages/HomePage';
import { SearchResultsPage } from './pages/SearchResultsPage';
import type { TripSearch } from './types/search';
const initialSearch: TripSearch = {
  service: 'destination',
  pickup: 'Kathmandu',
  drop: 'Pokhara',
  date: '',
  time: '',
  shift: 'day'
};
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31bibtsjf0ui2">
      <AppRoutes data-id="element-1" data-mp="31c1j8fbfw0hu" />
    </BrowserRouter>;
}
function AppRoutes() {
  const [tripSearch, setTripSearch] = useState<TripSearch>(initialSearch);
  const navigate = useNavigate();
  function handleSearch(search: TripSearch) {
    setTripSearch(search);
    navigate('/search');
  }
  return <div className="min-h-full w-full bg-white" data-id="element-2" data-mp="23utby4e102bb">
      <Header data-id="element-3" data-mp="3ik7fce9tu7pl" />
      <Routes data-id="element-4" data-mp="3ikqzm1my986s">
        <Route path="/" element={<HomePage onSearch={handleSearch} data-id="element-6" data-mp="3ijpc2xoqyt86" />} data-id="element-5" data-mp="3iiwaeb4natww" />
        <Route path="/search" element={<SearchResultsPage tripSearch={tripSearch} data-id="element-8" data-mp="3mk868ye44bdj" />} data-id="element-7" data-mp="3ml1419v3fqjj" />
        <Route path="/book" element={<BookNowPage tripSearch={tripSearch} data-id="element-10" data-mp="3rdaqgfx028h2" />} data-id="element-9" data-mp="3rcj5s04xxv5k" />
        <Route path="/contact" element={<ContactPage data-id="element-12" data-mp="6hp9c27i9cj" />} data-id="element-11" data-mp="3relumgucxi8p" />
        <Route path="*" element={<HomePage onSearch={handleSearch} data-id="element-14" data-mp="56lhc8rh1lf" />} data-id="element-13" data-mp="4n53zyrel9i" />
      </Routes>
      <Footer data-id="element-15" data-mp="2zm4y4lnitf2c" />
    </div>;
}